export const PROCESSING_WORKING_SCHEDULE = "PROCESSING_WORKING_SCHEDULE";
export const GET_FILLED_SHIFTS = "GET_FILLED_SHIFTS";
export const GET_WORKING_SCHEDULE = "GET_WORKING_SCHEDULE";
export const SET_WORKING_SCHEDULE = "SET_WORKING_SCHEDULE";
export const SET_COMPLETED_SCHEDULE = "SET_COMPLETED_SCHEDULE";
